import React, { useState } from "react";

const ResizeHandle = ({ edge, onPointerDown }) => {
  const [isHovered, setIsHovered] = useState(false);

  const isCorner = ["nw", "ne", "sw", "se"].includes(edge);

  // Larger hit targets for easier grabbing
  const edgeSize = 16; // Was 8 - doubled for easier targeting
  const cornerSize = 28; // Was 16 - increased for easier corner grabs
  const edgeOffset = -8; // Centered on border
  const cornerOffset = -10; // Extend into gutter for easier access

  const getHandleStyle = () => {
    const baseStyle = {
      position: "absolute",
      // Visual feedback on hover
      backgroundColor: isHovered ? "rgba(0, 164, 228, 0.3)" : "transparent",
      touchAction: "none",
      borderRadius: isCorner ? "4px" : "2px",
      transition: "background-color 0.15s ease",
    };

    switch (edge) {
      case "top":
        return {
          ...baseStyle,
          top: edgeOffset,
          left: cornerSize / 2,
          right: cornerSize / 2,
          height: edgeSize,
          cursor: "ns-resize",
          zIndex: 10,
        };
      case "bottom":
        return {
          ...baseStyle,
          bottom: edgeOffset,
          left: cornerSize / 2,
          right: cornerSize / 2,
          height: edgeSize,
          cursor: "ns-resize",
          zIndex: 10,
        };
      case "left":
        return {
          ...baseStyle,
          top: cornerSize / 2,
          bottom: cornerSize / 2,
          left: edgeOffset,
          width: edgeSize,
          cursor: "ew-resize",
          zIndex: 10,
        };
      case "right":
        return {
          ...baseStyle,
          top: cornerSize / 2,
          bottom: cornerSize / 2,
          right: edgeOffset,
          width: edgeSize,
          cursor: "ew-resize",
          zIndex: 10,
        };
      case "nw":
        return {
          ...baseStyle,
          top: cornerOffset,
          left: cornerOffset,
          width: cornerSize,
          height: cornerSize,
          cursor: "nwse-resize",
          zIndex: 12,
        };
      case "ne":
        return {
          ...baseStyle,
          top: cornerOffset,
          right: cornerOffset,
          width: cornerSize,
          height: cornerSize,
          cursor: "nesw-resize",
          zIndex: 12,
        };
      case "sw":
        return {
          ...baseStyle,
          bottom: cornerOffset,
          left: cornerOffset,
          width: cornerSize,
          height: cornerSize,
          cursor: "nesw-resize",
          zIndex: 12,
        };
      case "se":
        return {
          ...baseStyle,
          bottom: cornerOffset,
          right: cornerOffset,
          width: cornerSize,
          height: cornerSize,
          cursor: "nwse-resize",
          zIndex: 12,
        };
      default:
        return baseStyle;
    }
  };

  return (
    <div
      onPointerDown={onPointerDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid={`resize-handle-${edge}`}
      style={getHandleStyle()}
    />
  );
};

export default ResizeHandle;

